import { removeEmpty } from '@/utils/tools'

export default (obj) => {
  if (obj.id) return obj.id
  return removeEmpty(
    Object.keys(obj).map((key) =>
      typeof obj[key] === 'boolean' ? (obj[key] ? `${key}` : '') : `${key}|${obj[key]}`,
    ),
  ).join(',')
}
